import React, { useState, useEffect } from "react";
import useModal from "hook/useModal";

// css
import "assets/style/elements/status-label.scss";

function Element({ className, text = "", color = "" }) {
  return (
    <>
      <span className={"status-label " + color}>{text}</span>
    </>
  );
}

export default Element;
